'use strict';

var Sizzle = require('sizzle');
var statsUtil = require('../util/stats');

module.exports = (function () {

	function _getHLSVideoReference(videoReferences) {
		videoReferences = videoReferences || [];
		var hlsUrl = null,
			hlsWebVTTUrl = null;

		videoReferences.forEach(function (ref) {
			if (ref.format === 'hls') {
				hlsUrl = ref.url;
			} else if (ref.format === 'hlswebvtt') {
				hlsWebVTTUrl = ref.url;
			}
		});

		return {
			videos: [{playerType: 'ios', url: hlsWebVTTUrl || hlsUrl || '', bitrate: 0}]
		};
	}

	function _getVideoSettings(videoId, metadata, api) {
		var client = statsUtil.getClient(),
			programTitle = metadata.mmsStatistics.ns_st_pr || 'unknown_program',
			episodeTitle = metadata.mmsStatistics.ns_st_ep || 'unknown_episode',
			videoReference = _getHLSVideoReference(metadata.videoReferences),
			thumbnailImage = Sizzle('video', api.element())[0].getAttribute('poster') || 'http://www.svtplay.se/public/images/default/play_default_998x561.jpg';

		// Transform to a string that can be parsed as a 32-bit integer
		videoId = String(videoId).replace(/[^0-9]/g, '').substring(0, 10);

		if (thumbnailImage.indexOf('http') === -1) {
			thumbnailImage = 'http:' + thumbnailImage;
		} else {
			// The wrapper-apps don't like https-URLs for images, so ensure we use http
			thumbnailImage = thumbnailImage.replace(/^https/, 'http');
		}

		return {
			videoId: videoId,
			programVersionId: metadata.programVersionId,
			video: {
				videoReferences: videoReference.videos,
				materialLength: metadata.contentDuration,
				live: metadata.live || metadata.simulcast || false,
				livestartUTC: metadata.liveStartTimeUTC || 0, // default to 0 to avoid NPE in Java
				livestart: 0,
				dvr: metadata.timeshiftEnabled || false,
				blockedForChildren: metadata.blockedForChildren || false
			},
			statistics: {
				client: client,
				mmsClientNr: statsUtil.getMmsClientNr(),
				programId: metadata.programVersionId,
				statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + programTitle + '.' + episodeTitle,
				title: episodeTitle,
				category: metadata.mmsStatistics.ns_st_pl,
				folderStructure: programTitle,
				mmsCategory: metadata.live || metadata.simulcast ? 8 : 1 //hack for the old android lib to send the correct live flag
			},
			context: {
				title: metadata.episodeTitle,
				programTitle: metadata.programTitle,
				thumbnailImage: thumbnailImage
			}
		};
	}

	return {
		build: _getVideoSettings
	};
})();



// WEBPACK FOOTER //
// ./src/js/util/video-data-builder.js